import configSelector from "../../external/configSelector";
import Card from "@urbanpiper-engineering/meraki-components/dist/Atoms/Card";
import { getStaticProps as getInitialProps } from "../../hooks/server.props";
import SeoData from "../../components/seo_data";
import styles from "./custom.module.scss";

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export async function getStaticProps(ctx: any) {
  const intialProps = await getInitialProps(ctx);

  const slug = ctx.params.slug;
  const customPages = configSelector.getCustomPages();
  const page = customPages.find((page: any) => page.path.substring(1) === slug);

  const seoData = page?.seo?.[ctx.locale] || {};

  const primaryDomain = configSelector.getPrimaryDomain();
  const openGraphData = {
    title: seoData?.title || page?.name || null,
    description: seoData?.description || null,
    url:
      primaryDomain?.url?.length > 0
        ? `https://${primaryDomain?.url}/${slug}`
        : null,
    image: null,
  };

  return {
    props: {
      ...intialProps.props,
      page,
      seoData,
      openGraphData,
    },
  };
}

function CustomPage({ page, seoData, openGraphData }: any) {
  return (
    <div className={styles.custom}>
      <SeoData seoData={seoData} openGraphData={openGraphData} />
      <h1 className="visually-hidden">{seoData?.title || page?.name}</h1>
      <Card>
        <div dangerouslySetInnerHTML={{ __html: page?.content }} />
      </Card>
    </div>
  );
}

export default CustomPage;
